import { useAuth0 } from "@auth0/auth0-react";
import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import TransactionsTableSortable from '../components/TransactionsTableSortable'
import TransactionsGetStarted from "../components/GetStarted/TransactionsGetStarted";
import LoadingSpinner from '../components/ui/LoadingSpinner'
import { svc_getTransactions } from "../services/transaction.service";
import { dateHandler } from "../utilities/date-utils";

function Transactions() {
    const { getAccessTokenSilently, user } = useAuth0();
    const [transactionsList, setTransactionsList] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [ searchParams ] = useSearchParams();
    const snowball = searchParams.get('snowball')

    const getTransactions = async () => {
        const accessToken = await getAccessTokenSilently();
        const { data } = await svc_getTransactions(accessToken, user.sub)

        if (data) {
            const processed = createFirstInstanceOfEachTransaction(data)
            const sortedByTitle = processed.sort(
                (a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()),
            )
            setTransactionsList(sortedByTitle)
        }

        setIsLoading(false)
    }

    const createFirstInstanceOfEachTransaction = (transactions) =>
        transactions.map((transaction) => {
            return Object.assign({}, transaction, {
                instanceDate: dateHandler.toZeroHoursFormat(transaction.start_date),
            })
        })

    useEffect(() => {
        if (!transactionsList) {
            getTransactions()
        }
    }, [])

    return (
        <div>
            <h1 className="text-center">My Transactions</h1>

            {isLoading ? (
                <LoadingSpinner />
            ) : (
                transactionsList && transactionsList.length ? (
                    <TransactionsTableSortable
                        items={transactionsList}
                        snowballParam={snowball}
                    />
                ) : (
                    <div className="text-center">
                        <p>No transactions found.</p>
                    </div>
                )
            )}

            <div style={{
                margin: '2rem auto 0',
                padding: '2rem 1rem',
            }}>
                <TransactionsGetStarted />
            </div>
        </div>
    )
}

export default Transactions
